module.exports = __webpack_public_path__ + "img/荔枝核.d11fd18d.jpg";